import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarningFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "M12.448 3.386c-1.087-1.848-3.818-1.848-4.905 0L1.379 13.863C.274 15.742 1.702 18 3.832 18h12.327c2.13 0 3.559-2.258 2.453-4.137L12.45 3.386ZM9.25 15.25a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-1.5 0v1.5Zm0-5a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-1.5 0v3.5Z",
		clipRule: "evenodd"
	})]
});
const ForwardRef = forwardRef(SvgWarningFill);
export { ForwardRef as ReactComponent };
